import React, { useEffect, useState } from "react";
import { Drawer } from "rsuite";
import { Genders } from "../../Helpers/AppConstants";
import { DepartmentsStat } from "./DepartmentsStat";
import { EmployeeGenderStat } from "./EmployeeGenderStat";
import { ShiftWorkStat } from "./ShiftWorkStat";
import { SingleStat } from "./SingleStat";
import * as userManager from "../../Services/UserSessionManager";
import { EmployeeInfoModal } from "../EmployeeTeamDetail/EmployeeInfomodal";
import { EmployeeDetails } from "../EmployeeInformation/EmployeeDetails";
// type attributes = {
//     city: string
// }

export const DashboardThree = ({ city }: any) => {
  const activedepartments: object[] = [];
  const [departments, setActivedepartments] = useState(0);
  const getActiveDepartments = () => {

    city.departments.map((depts: any) => {
      if (depts.TotalCount > 0) {
        activedepartments.push(depts);
      }
    });
    setActivedepartments(activedepartments.length);
    return activedepartments.length;
  };

  useEffect(() => {
    getActiveDepartments();
  }, []);
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div>
        <div className="d-flex flex-column gap-1">
          <div className="d-flex justify-content-center align-items-center gap-4">
            <SingleStat title="Total Employees" value={city.TotalCount} />

            <div className="md-1">
              <div className="mb-4">Gender Share</div>
              {city.Gender.length > 1 ? (
                <EmployeeGenderStat
                  male={city.Gender[1].count}
                  female={city.Gender[0].count}
                  size={250}
                />
              ) : city.Gender[0].gender == "MALE" ? (
                <EmployeeGenderStat
                  male={city.Gender[0].count}
                  female={0}
                  size={250}
                />
              ) : (
                <EmployeeGenderStat
                  male={0}
                  female={city.Gender[0].count}
                  size={250}
                />
              )}
            </div>
            <SingleStat
              title="Departments"
              value={departments}
              onClick={() => setOpen(true)}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center mt-3 gap-4">
            <div className="d-flex flex-row gap-3">
              {city.Shifts.length > 1 ?
                city.Shifts[0].GenderCount.length==1 && city.Shifts[1].GenderCount.length==1 ?
                    city.Shifts[0].GenderCount[0]=="MALE"?
                        city.Shifts[1].GenderCount[0]=="MALE"?
                        <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={0}
                        nightShiftCount={0}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count 
                        }
                        />
                    </div>
                    :
                    <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={0}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={0}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count 
                        }
                        />
                    </div>
                    :
                    city.Shifts[1].GenderCount[0]=="MALE"?
                    <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={0}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={0}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count 
                        }
                        />
                    </div>
                    :
                    <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={0}
                        nightShiftCount={0}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count 
                        }
                        />
                    </div>
                    :
                    city.Shifts[0].GenderCount.length==1 && city.Shifts[1].GenderCount.length>1?
                        city.Shifts[0].GenderCount[0]=="MALE"?
                        <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={city.Shifts[1].GenderCount[1].Count}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={0}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count +
                            city.Shifts[1].GenderCount[1].count
                        }
                        />
                    </div>
                :
                <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={0}
                        nightShiftCount={city.Shifts[1].GenderCount[1].count}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={city.Shifts[1].GenderCount[1].count}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count +
                            city.Shifts[1].GenderCount[1].count
                        }
                        />
                    </div>
                :
                city.Shifts[0].GenderCount.length>1 && city.Shifts[1].GenderCount.length==1?
                city.Shifts[1].GenderCount[0]=="MALE"?
                <div>
                <ShiftWorkStat
                title={Genders.MALE}
                dayShiftCount={city.Shifts[0].GenderCount[1].count}
                nightShiftCount={city.Shifts[1].GenderCount[1].count}
                />
                <ShiftWorkStat
                title={Genders.FEMALE}
                dayShiftCount={city.Shifts[0].GenderCount[0].count}
                nightShiftCount={0}
                />
                <ShiftWorkStat
                title={"Total"}
                dayShiftCount={
                    city.Shifts[0].GenderCount[0].count+
                    city.Shifts[0].GenderCount[1].count
                }
                nightShiftCount={
                    city.Shifts[1].GenderCount[0].count 
                }
                />
            </div>
            :
            <div>
            <ShiftWorkStat
            title={Genders.MALE}
            dayShiftCount={city.Shifts[0].GenderCount[1].count}
            nightShiftCount={0}
            />
            <ShiftWorkStat
            title={Genders.FEMALE}
            dayShiftCount={city.Shifts[0].GenderCount[0].count}
            nightShiftCount={city.Shifts[1].GenderCount[0].count}
            />
            <ShiftWorkStat
            title={"Total"}
            dayShiftCount={
                city.Shifts[0].GenderCount[0].count+
                city.Shifts[0].GenderCount[1].count
            }
            nightShiftCount={
                city.Shifts[1].GenderCount[0].count 
            }
            />
        </div>
        :
              (
                    <div>
                        <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={city.Shifts[0].GenderCount[1].count}
                        nightShiftCount={city.Shifts[1].GenderCount[1].count}
                        />
                        <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={city.Shifts[1].GenderCount[0].count}
                        />
                        <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={
                            city.Shifts[0].GenderCount[1].count +
                            city.Shifts[0].GenderCount[0].count
                        }
                        nightShiftCount={
                            city.Shifts[1].GenderCount[0].count +
                            city.Shifts[1].GenderCount[1].count
                        }
                        />
                    </div>
                
              ) : city.Shifts[0].ShiftName == "DAY SHIFT" ? (
                city.Shifts[0].GenderCount.length == 1 ? (
                  city.Shifts[0].GenderCount[0].gender == "MALE" ? (
                    <div>
                      <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={0}
                      />
                      <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={0}
                        nightShiftCount={0}
                      />
                      <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count + 0}
                        nightShiftCount={0}
                      />
                    </div>
                  ) : (
                    <div>
                      <ShiftWorkStat
                        title={Genders.MALE}
                        dayShiftCount={0}
                        nightShiftCount={0}
                      />
                      <ShiftWorkStat
                        title={Genders.FEMALE}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count}
                        nightShiftCount={0}
                      />
                      <ShiftWorkStat
                        title={"Total"}
                        dayShiftCount={city.Shifts[0].GenderCount[0].count + 0}
                        nightShiftCount={0}
                      />
                    </div>
                  )
                ) : (
                  <div>
                    <ShiftWorkStat
                      title={Genders.MALE}
                      dayShiftCount={city.Shifts[0].GenderCount[1].count}
                      nightShiftCount={0}
                    />
                    <ShiftWorkStat
                      title={Genders.FEMALE}
                      dayShiftCount={city.Shifts[0].GenderCount[0].count}
                      nightShiftCount={0}
                    />
                    <ShiftWorkStat
                      title={"Total"}
                      dayShiftCount={
                        city.Shifts[0].GenderCount[0].count +
                        city.Shifts[0].GenderCount[1].count
                      }
                      nightShiftCount={0}
                    />
                  </div>
                )
              ) : city.Shifts[0].GenderCount.length == 1 ? (
                city.Shifts[0].GenderCount[0].gender == "MALE" ? (
                  <div>
                    <ShiftWorkStat
                      title={Genders.MALE}
                      dayShiftCount={0}
                      nightShiftCount={city.Shifts[0].GenderCount[0].count}
                    />
                    <ShiftWorkStat
                      title={Genders.FEMALE}
                      dayShiftCount={0}
                      nightShiftCount={0}
                    />
                    <ShiftWorkStat
                      title={"Total"}
                      dayShiftCount={0}
                      nightShiftCount={city.Shifts[0].GenderCount[0].count + 0}
                    />
                  </div>
                ) : (
                  <div>
                    <ShiftWorkStat
                      title={Genders.MALE}
                      dayShiftCount={0}
                      nightShiftCount={0}
                    />
                    <ShiftWorkStat
                      title={Genders.FEMALE}
                      dayShiftCount={0}
                      nightShiftCount={city.Shifts[0].GenderCount[0].count}
                    />
                    <ShiftWorkStat
                      title={"Total"}
                      dayShiftCount={0}
                      nightShiftCount={city.Shifts[0].GenderCount[0].count + 0}
                    />
                  </div>
                )
              ) : (
                <div>
                  <ShiftWorkStat
                    title={Genders.MALE}
                    dayShiftCount={0}
                    nightShiftCount={city.Shifts[0].GenderCount[1].count}
                  />
                  <ShiftWorkStat
                    title={Genders.FEMALE}
                    dayShiftCount={0}
                    nightShiftCount={city.Shifts[0].GenderCount[0].count}
                  />
                  <ShiftWorkStat
                    title={"Total"}
                    dayShiftCount={0}
                    nightShiftCount={
                      city.Shifts[0].GenderCount[0].count +
                      city.Shifts[0].GenderCount[1].count
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <Drawer open={open} onClose={() => setOpen(false)}>
          <Drawer.Body>
            <DepartmentsStat
              city={city.CityName}
              departmentDetails={city.departments}
            />
          </Drawer.Body>
        </Drawer>
      </div>
    </>
  );
};
